import React from "react";
import { ShieldCheck, BadgeCheck, Crown } from "lucide-react";

export default function UserBadge({ user, size = "sm" }) {
  if (!user) return null;
  const cls = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";
  return (
    <span className="inline-flex items-center gap-1" data-testid="user-badges">
      {user.is_admin && (
        <span title="Admin" className="inline-flex items-center text-purple-300" data-testid="badge-admin">
          <Crown className={cls} />
        </span>
      )}
      {user.is_critic && (
        <span title="Verified Critic" className="inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] uppercase tracking-wider bg-amber text-obsidian font-heading" data-testid="badge-critic">
          <ShieldCheck className="h-3 w-3" /> Critic
        </span>
      )}
      {user.is_verified && !user.is_critic && (
        <span title="Verified" className="inline-flex items-center text-sky-300" data-testid="badge-verified">
          <BadgeCheck className={cls} />
        </span>
      )}
    </span>
  );
}
